// src/components/website/Topsection.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { usePopup } from './PopupContext';
import 'animate.css/animate.min.css';

const Topsection = () => {
  const { setShowPopup } = usePopup();

  const handleEnquiryClick = (e) => {
    e.preventDefault();
    setShowPopup(true);
  };

  return (
    <>
    <div className="top-bar w-100 py-2 border-bottom d-none d-sm-block bgcolor1 position-sticky myfont1" style={{ zIndex: 1040, top: 0 }}>
      <div className="container d-flex justify-content-end gap-4">
        <a href="tel:9766439090" className="text-decoration-none text-white fw-bold">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" className="bi bi-telephone" viewBox="0 0 16 16">
            <path d="M3.654 1.328a...z" />
          </svg>&nbsp; +91-9766439090
        </a>
        <Link to="/batchschedule" className="text-decoration-none text-white fw-bold">
          Batch Schedule
        </Link>
        {/* <Link to="/current_openings" className="text-decoration-none text-dark small fw-bold">
          Current Openings
        </Link> */}
        <Link to="/enquiryform" onClick={handleEnquiryClick} className="text-decoration-none text-white fw-bold d-none d-sm-block" role="button" tabIndex={0}>
          Enquiry Form
        </Link>
      </div>
    </div>
    {/* <div className='d-none d-sm-block'><br/><br/></div> */}
    </>
  );
};

export default Topsection;
